import BlogPostSkeletonCard from './BlogPostSkeletonCard';

export default BlogPostSkeletonCard;
